import apiService from './api-service';

export const couponService = {
	getCoupons,
	createCoupon,
	updateCoupon,
	deleteCoupon
};

async function getCoupons() {
	const coupons = await apiService.get('coupon/getCoupons');
	return coupons;
}

async function createCoupon(coupon) {
	const countInsertedRows = await apiService.post('coupon/createCoupon', coupon);
	return countInsertedRows;
}

async function updateCoupon(coupon) {
	const countUpdatedRows = await apiService.post('coupon/updateCoupon', coupon);
	return countUpdatedRows;
}

async function deleteCoupon(couponId) {
	const coupon = { couponId: couponId };

	const countDeletedRows = await apiService.post('coupon/deleteCoupon', coupon);
	return countDeletedRows;
}